import { AuthStore, useAuthStore } from "@/stores/auth";
import { Response } from "../types";

export class AuthenticatedService {

    authStore = useAuthStore();

    constructor(){
        this.authStore = useAuthStore()
    }

    /**
     * Token del usuario autenticado. En caso de no estar autenticado, se
     * genera una excepción
     */
    get token(): string{
        if(!this.authStore.token){
            throw new Error("Usuario no autenticado")
        }

        return this.authStore.token!
    }
}
